import React from 'react';
import { SvgIcon, useTheme } from '@mui/material';

export default function GreenTickIcon(props) {
  const theme = useTheme();

  return (
    <SvgIcon inheritViewBox {...props}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask id="path-1-inside-1_5326_47465" fill="white">
          <path d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z" />
        </mask>
        <path
          d="M16 30C8.26801 30 2 23.732 2 16H-2C-2 25.9411 6.05887 34 16 34V30ZM30 16C30 23.732 23.732 30 16 30V34C25.9411 34 34 25.9411 34 16H30ZM16 2C23.732 2 30 8.26801 30 16H34C34 6.05887 25.9411 -2 16 -2V2ZM16 -2C6.05887 -2 -2 6.05887 -2 16H2C2 8.26801 8.26801 2 16 2V-2Z"
          fill={theme.palette.success.main}
          mask="url(#path-1-inside-1_5326_47465)"
        />
        <path
          d="M9 16L14 21L23 11"
          stroke={theme.palette.success.main}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
